import type { ActivationAlertsContractSocialMediaGroup } from "@similarweb/pro-api-client";

import type { IWebsitesFavicons } from "app/services/sitesService/types";

import { useSelectedGroupItemStore } from "../../../common/modal/useSelectedGroupItemStore";

import { SocialPostModalInner } from "./SocialPostModalInner";

interface ISocialPostModalProps {
    favicons?: IWebsitesFavicons;
    groups: ActivationAlertsContractSocialMediaGroup[];
}

export const SocialPostModal = ({ favicons, groups }: ISocialPostModalProps) => {
    const selectedGroupIndex = useSelectedGroupItemStore((store) => store.selectedGroupIndex);

    if (selectedGroupIndex == null) {
        return null;
    }

    const group = groups[selectedGroupIndex];

    if (!group || !group.postsCount) {
        return null;
    }

    return (
        <SocialPostModalInner
            favicon={favicons?.[group.domain] ?? ""}
            group={group}
        />
    );
};
